export const isExpiryPassed = (exp: number) => {
  // convert to seconds to match 'exp'
  const currentTimestamp = Math.floor(Date.now() / 1000)
  return exp < currentTimestamp
}

export const isSessionExpired = (session: { exp: number }) => {
  return isExpiryPassed(session.exp)
}

export const timeLeftOnSession = (session: { exp: number }) => {
  // convert to seconds to match 'exp'
  const currentTimestamp = Math.floor(Date.now() / 1000)
  // return session.exp - currentTimestamp

  // convert to MM:SS as a string
  const secondsLeft = session.exp - currentTimestamp
  const minutesLeft = Math.floor(secondsLeft / 60)
  const secondsRemainder = secondsLeft % 60
  const secondsString = secondsRemainder.toString().padStart(2, '0')

  if (minutesLeft < 0) return '0:00'

  return `${minutesLeft}:${secondsString}`
}

export const buildBasicAuthBase64 = (
  id: string | number,
  secret: string | number,
) => {
  return Buffer.from(`${id}:${secret}`).toString('base64')
}
